<xemex-page-header
  [title]="'sidebarMenu.installationGroups' | translate"
  [breadcrumbs]="breadcrumbs"
>
  @if (canManage()) {
    <xemex-filled-button actions type="button" icon="add" (click)="openCreateDialog()">
      {{ 'installationGroups.create.title' | translate }}
    </xemex-filled-button>
  }
</xemex-page-header>

<xemex-page-body>
  <xemex-table
    [data]="tableData()"
    [columns]="columns"
    [loading]="installationGroupStore.isLoading()"
    [totalCount]="totalCount()"
    [rowLink]="rowLink"
    (pageChange)="onPageChange($event)"
  >
    @if (isXemexUser()) {
      <xemex-table-filter-bar
        [filterGroups]="filterGroups()"
        [showSearch]="false"
        (filterChange)="onFilterChange($event)"
      >
        <div actions class="flex items-center gap-2">
          <button
            mat-icon-button
            #dateMenuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="dateMenu"
            [color]="hasActiveDateRange() ? 'primary' : ''"
            [matTooltip]="'installationGroups.filter.dateRange' | translate"
          >
            <mat-icon>date_range</mat-icon>
          </button>

          <mat-menu #dateMenu="matMenu">
            <div
              class="min-w-[340px] p-4 flex flex-col gap-3"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            >
              <xemex-date-field
                [label]="'installationGroups.filter.createdAfter' | translate"
                [(ngModel)]="pendingCreatedAfter"
              />
              <xemex-date-field
                [label]="'installationGroups.filter.createdBefore' | translate"
                [(ngModel)]="pendingCreatedBefore"
              />

              <div class="flex gap-2 mt-1">
                <xemex-outlined-button
                  [fullWidth]="true"
                  class="flex-1"
                  (click)="onDateRangeClear(dateMenuTrigger)"
                >
                  {{ 'general.btnClear' | translate }}
                </xemex-outlined-button>
                <xemex-filled-button
                  [fullWidth]="true"
                  class="flex-1"
                  (click)="onDateRangeApply(dateMenuTrigger)"
                >
                  {{ 'general.btnApply' | translate }}
                </xemex-filled-button>
              </div>
            </div>
          </mat-menu>
        </div>
      </xemex-table-filter-bar>
    } @else {
      <xemex-table-filter-bar> </xemex-table-filter-bar>
    }
  </xemex-table>
</xemex-page-body>
